import { Instant3cn81rq2kpflk as Instant } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { DurationSerializer_getInstanceo50ej00g6vz5 as DurationSerializer_getInstance } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import {
  Duration5ynfiptaqcrg as Duration,
  Duration__toString_impl_8d916b11f1kpclwmkpg as Duration__toString_impl_8d916b,
  Duration__hashCode_impl_u4exz629donm5f9ouki as Duration__hashCode_impl_u4exz6,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function Proof$Companion$$childSerializers$_anonymous__u3hxay() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.t3j_1 = [null, null, null, null, lazy(tmp_0, Proof$Companion$$childSerializers$_anonymous__u3hxay), null];
      }
      m2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.Proof', this, 6);
        tmp0_serialDesc.c1b('via', false);
        tmp0_serialDesc.c1b('strength', true);
        tmp0_serialDesc.c1b('property', false);
        tmp0_serialDesc.c1b('value', false);
        tmp0_serialDesc.c1b('at', false);
        tmp0_serialDesc.c1b('signature', false);
        this.w4h_1 = tmp0_serialDesc;
      }
      x4h(encoder, value) {
        var tmp0_desc = this.w4h_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance().t3j_1;
        tmp1_output.a15(tmp0_desc, 0, value.y4h_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.z4h_1 === 1)) {
          tmp1_output.v14(tmp0_desc, 1, value.z4h_1);
        }
        tmp1_output.a15(tmp0_desc, 2, value.a4i_1);
        tmp1_output.a15(tmp0_desc, 3, value.b4i_1);
        tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.c4i_1);
        tmp1_output.a15(tmp0_desc, 5, value.d4i_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.x4h(encoder, value instanceof Proof() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.w4h_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = 0;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_input = decoder.l13(tmp0_desc);
        var tmp11_cached = Companion_getInstance().t3j_1;
        if (tmp10_input.a14()) {
          tmp4_local0 = tmp10_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp10_input.q13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp10_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp10_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp10_input.x13(tmp0_desc, 4, tmp11_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp10_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp10_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp10_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp10_input.q13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp10_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp10_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp10_input.x13(tmp0_desc, 4, tmp11_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp10_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp10_input.m13(tmp0_desc);
        return Proof().e4i(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
      }
      az() {
        return this.w4h_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance().t3j_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[4].f2(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var ProofClass;
function Proof() {
  if (ProofClass === VOID) {
    class $ {
      toString() {
        return 'Proof(via=' + this.y4h_1 + ', strength=' + this.z4h_1 + ', property=' + this.a4i_1 + ', value=' + this.b4i_1 + ', at=' + this.c4i_1.toString() + ', signature=' + this.d4i_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.y4h_1);
        result = imul(result, 31) + this.z4h_1 | 0;
        result = imul(result, 31) + getStringHashCode(this.a4i_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.b4i_1) | 0;
        result = imul(result, 31) + this.c4i_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.d4i_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Proof()))
          return false;
        if (!(this.y4h_1 === other.y4h_1))
          return false;
        if (!(this.z4h_1 === other.z4h_1))
          return false;
        if (!(this.a4i_1 === other.a4i_1))
          return false;
        if (!(this.b4i_1 === other.b4i_1))
          return false;
        if (!this.c4i_1.equals(other.c4i_1))
          return false;
        if (!(this.d4i_1 === other.d4i_1))
          return false;
        return true;
      }
      static e4i(seen0, via, strength, property, value, at, signature, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(61 === (61 & seen0))) {
          throwMissingFieldException(seen0, 61, $serializer_getInstance().w4h_1);
        }
        var $this = createThis(this);
        $this.y4h_1 = via;
        if (0 === (seen0 & 2))
          $this.z4h_1 = 1;
        else
          $this.z4h_1 = strength;
        $this.a4i_1 = property;
        $this.b4i_1 = value;
        $this.c4i_1 = at;
        $this.d4i_1 = signature;
        return $this;
      }
    }
    initMetadataForClass($, 'Proof', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    ProofClass = $;
  }
  return ProofClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.FinishProof', this, 2);
        tmp0_serialDesc.c1b('key', false);
        tmp0_serialDesc.c1b('password', false);
        this.f4i_1 = tmp0_serialDesc;
      }
      g4i(encoder, value) {
        var tmp0_desc = this.f4i_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.h4i_1);
        tmp1_output.a15(tmp0_desc, 1, value.i4i_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.g4i(encoder, value instanceof FinishProof() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.f4i_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return FinishProof().j4i(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.f4i_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var FinishProofClass;
function FinishProof() {
  if (FinishProofClass === VOID) {
    class $ {
      constructor(key, password) {
        this.h4i_1 = key;
        this.i4i_1 = password;
      }
      toString() {
        return 'FinishProof(key=' + this.h4i_1 + ', password=' + this.i4i_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.h4i_1);
        result = imul(result, 31) + getStringHashCode(this.i4i_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FinishProof()))
          return false;
        if (!(this.h4i_1 === other.h4i_1))
          return false;
        if (!(this.i4i_1 === other.i4i_1))
          return false;
        return true;
      }
      static j4i(seen0, key, password, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_0().f4i_1);
        }
        var $this = createThis(this);
        $this.h4i_1 = key;
        $this.i4i_1 = password;
        return $this;
      }
    }
    initMetadataForClass($, 'FinishProof', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    FinishProofClass = $;
  }
  return FinishProofClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.IdentificationAndPassword', this, 4);
        tmp0_serialDesc.c1b('type', false);
        tmp0_serialDesc.c1b('property', false);
        tmp0_serialDesc.c1b('value', false);
        tmp0_serialDesc.c1b('password', false);
        this.k4i_1 = tmp0_serialDesc;
      }
      l4i(encoder, value) {
        var tmp0_desc = this.k4i_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.m4i_1);
        tmp1_output.a15(tmp0_desc, 1, value.n4i_1);
        tmp1_output.a15(tmp0_desc, 2, value.o4i_1);
        tmp1_output.a15(tmp0_desc, 3, value.p4i_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.l4i(encoder, value instanceof IdentificationAndPassword() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.k4i_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return IdentificationAndPassword().q4i(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.k4i_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var IdentificationAndPasswordClass;
function IdentificationAndPassword() {
  if (IdentificationAndPasswordClass === VOID) {
    class $ {
      toString() {
        return 'IdentificationAndPassword(type=' + this.m4i_1 + ', property=' + this.n4i_1 + ', value=' + this.o4i_1 + ', password=' + this.p4i_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.m4i_1);
        result = imul(result, 31) + getStringHashCode(this.n4i_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.o4i_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.p4i_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IdentificationAndPassword()))
          return false;
        if (!(this.m4i_1 === other.m4i_1))
          return false;
        if (!(this.n4i_1 === other.n4i_1))
          return false;
        if (!(this.o4i_1 === other.o4i_1))
          return false;
        if (!(this.p4i_1 === other.p4i_1))
          return false;
        return true;
      }
      static q4i(seen0, type, property, value, password, serializationConstructorMarker) {
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_1().k4i_1);
        }
        var $this = createThis(this);
        $this.m4i_1 = type;
        $this.n4i_1 = property;
        $this.o4i_1 = value;
        $this.p4i_1 = password;
        return $this;
      }
    }
    initMetadataForClass($, 'IdentificationAndPassword', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    IdentificationAndPasswordClass = $;
  }
  return IdentificationAndPasswordClass;
}
function AuthRequirements$Companion$$childSerializers$_anonymous__d2n0lu() {
  return new (ArrayListSerializer())($serializer_getInstance_3());
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.s3j_1 = [lazy(tmp_0, AuthRequirements$Companion$$childSerializers$_anonymous__d2n0lu), null];
      }
      m2a() {
        return $serializer_getInstance_2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  if (Companion_instance_2 === VOID)
    new (Companion_2())();
  return Companion_instance_2;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.AuthRequirements', this, 2);
        tmp0_serialDesc.c1b('options', false);
        tmp0_serialDesc.c1b('strengthRequired', false);
        this.r4i_1 = tmp0_serialDesc;
      }
      s4i(encoder, value) {
        var tmp0_desc = this.r4i_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().s3j_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.t4i_1);
        tmp1_output.v14(tmp0_desc, 1, value.u4i_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.s4i(encoder, value instanceof AuthRequirements() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.r4i_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = 0;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_2().s3j_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.q13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.q13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return AuthRequirements().v4i(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.r4i_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_2().s3j_1[0].f2(), IntSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
var AuthRequirementsClass;
function AuthRequirements() {
  if (AuthRequirementsClass === VOID) {
    class $ {
      toString() {
        return 'AuthRequirements(options=' + toString(this.t4i_1) + ', strengthRequired=' + this.u4i_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.t4i_1);
        result = imul(result, 31) + this.u4i_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AuthRequirements()))
          return false;
        if (!equals(this.t4i_1, other.t4i_1))
          return false;
        if (!(this.u4i_1 === other.u4i_1))
          return false;
        return true;
      }
      static v4i(seen0, options, strengthRequired, serializationConstructorMarker) {
        Companion_getInstance_2();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_2().r4i_1);
        }
        var $this = createThis(this);
        $this.t4i_1 = options;
        $this.u4i_1 = strengthRequired;
        return $this;
      }
    }
    initMetadataForClass($, 'AuthRequirements', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
    AuthRequirementsClass = $;
  }
  return AuthRequirementsClass;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_3();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.ProofOption', this, 2);
        tmp0_serialDesc.c1b('method', false);
        tmp0_serialDesc.c1b('value', true);
        this.w4i_1 = tmp0_serialDesc;
      }
      x4i(encoder, value) {
        var tmp0_desc = this.w4i_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, $serializer_getInstance_4(), value.y4i_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.z4i_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.z4i_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.x4i(encoder, value instanceof ProofOption() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.w4i_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, $serializer_getInstance_4(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, $serializer_getInstance_4(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return ProofOption().a4j(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.w4i_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_4(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
var ProofOptionClass;
function ProofOption() {
  if (ProofOptionClass === VOID) {
    class $ {
      toString() {
        return 'ProofOption(method=' + this.y4i_1.toString() + ', value=' + this.z4i_1 + ')';
      }
      hashCode() {
        var result = this.y4i_1.hashCode();
        result = imul(result, 31) + (this.z4i_1 == null ? 0 : getStringHashCode(this.z4i_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProofOption()))
          return false;
        if (!this.y4i_1.equals(other.y4i_1))
          return false;
        if (!(this.z4i_1 == other.z4i_1))
          return false;
        return true;
      }
      static a4j(seen0, method, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_3().w4i_1);
        }
        var $this = createThis(this);
        $this.y4i_1 = method;
        if (0 === (seen0 & 2))
          $this.z4i_1 = null;
        else
          $this.z4i_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'ProofOption', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
    ProofOptionClass = $;
  }
  return ProofOptionClass;
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_4();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.ProofMethodInfo', this, 3);
        tmp0_serialDesc.c1b('via', false);
        tmp0_serialDesc.c1b('property', false);
        tmp0_serialDesc.c1b('strength', true);
        this.b4j_1 = tmp0_serialDesc;
      }
      c4j(encoder, value) {
        var tmp0_desc = this.b4j_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.d4j_1);
        tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.e4j_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.f4j_1 === 1)) {
          tmp1_output.v14(tmp0_desc, 2, value.f4j_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.c4j(encoder, value instanceof ProofMethodInfo() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.b4j_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = 0;
        var tmp7_input = decoder.l13(tmp0_desc);
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.q13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.q13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return ProofMethodInfo().g4j(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.b4j_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), IntSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_4() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
var ProofMethodInfoClass;
function ProofMethodInfo() {
  if (ProofMethodInfoClass === VOID) {
    class $ {
      toString() {
        return 'ProofMethodInfo(via=' + this.d4j_1 + ', property=' + this.e4j_1 + ', strength=' + this.f4j_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.d4j_1);
        result = imul(result, 31) + (this.e4j_1 == null ? 0 : getStringHashCode(this.e4j_1)) | 0;
        result = imul(result, 31) + this.f4j_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProofMethodInfo()))
          return false;
        if (!(this.d4j_1 === other.d4j_1))
          return false;
        if (!(this.e4j_1 == other.e4j_1))
          return false;
        if (!(this.f4j_1 === other.f4j_1))
          return false;
        return true;
      }
      static g4j(seen0, via, property, strength, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_4().b4j_1);
        }
        var $this = createThis(this);
        $this.d4j_1 = via;
        $this.e4j_1 = property;
        if (0 === (seen0 & 4))
          $this.f4j_1 = 1;
        else
          $this.f4j_1 = strength;
        return $this;
      }
    }
    initMetadataForClass($, 'ProofMethodInfo', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
    ProofMethodInfoClass = $;
  }
  return ProofMethodInfoClass;
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_5();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
var $serializerClass_5;
function $serializer_5() {
  if ($serializerClass_5 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_5 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.Identification', this, 3);
        tmp0_serialDesc.c1b('type', false);
        tmp0_serialDesc.c1b('property', false);
        tmp0_serialDesc.c1b('value', false);
        this.h4j_1 = tmp0_serialDesc;
      }
      i4j(encoder, value) {
        var tmp0_desc = this.h4j_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.j4j_1);
        tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.k4j_1);
        tmp1_output.d15(tmp0_desc, 2, StringSerializer_getInstance(), value.l4j_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.i4j(encoder, value instanceof Identification() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.h4j_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.z13(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.z13(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return Identification().m4j(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.h4j_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_5 = $;
  }
  return $serializerClass_5;
}
var $serializer_instance_5;
function $serializer_getInstance_5() {
  if ($serializer_instance_5 === VOID)
    new ($serializer_5())();
  return $serializer_instance_5;
}
var IdentificationClass;
function Identification() {
  if (IdentificationClass === VOID) {
    class $ {
      toString() {
        return 'Identification(type=' + this.j4j_1 + ', property=' + this.k4j_1 + ', value=' + this.l4j_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.j4j_1);
        result = imul(result, 31) + (this.k4j_1 == null ? 0 : getStringHashCode(this.k4j_1)) | 0;
        result = imul(result, 31) + (this.l4j_1 == null ? 0 : getStringHashCode(this.l4j_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Identification()))
          return false;
        if (!(this.j4j_1 === other.j4j_1))
          return false;
        if (!(this.k4j_1 == other.k4j_1))
          return false;
        if (!(this.l4j_1 == other.l4j_1))
          return false;
        return true;
      }
      static m4j(seen0, type, property, value, serializationConstructorMarker) {
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_5().h4j_1);
        }
        var $this = createThis(this);
        $this.j4j_1 = type;
        $this.k4j_1 = property;
        $this.l4j_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'Identification', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
    IdentificationClass = $;
  }
  return IdentificationClass;
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_6();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
var $serializerClass_6;
function $serializer_6() {
  if ($serializerClass_6 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_6 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.KnownDeviceOptions', this, 2);
        tmp0_serialDesc.c1b('duration', false);
        tmp0_serialDesc.c1b('strength', false);
        this.n4j_1 = tmp0_serialDesc;
      }
      o4j(encoder, value) {
        var tmp0_desc = this.n4j_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, DurationSerializer_getInstance(), new (Duration())(value.p4j_1));
        tmp1_output.v14(tmp0_desc, 1, value.q4j_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.o4j(encoder, value instanceof KnownDeviceOptions() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.n4j_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = 0;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          var tmp = DurationSerializer_getInstance();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp6_input.x13(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (Duration())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.nj_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.q13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = DurationSerializer_getInstance();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp6_input.x13(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (Duration())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.nj_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.q13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return KnownDeviceOptions().r4j(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.n4j_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DurationSerializer_getInstance(), IntSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_6 = $;
  }
  return $serializerClass_6;
}
var $serializer_instance_6;
function $serializer_getInstance_6() {
  if ($serializer_instance_6 === VOID)
    new ($serializer_6())();
  return $serializer_instance_6;
}
var KnownDeviceOptionsClass;
function KnownDeviceOptions() {
  if (KnownDeviceOptionsClass === VOID) {
    class $ {
      toString() {
        return 'KnownDeviceOptions(duration=' + Duration__toString_impl_8d916b(this.p4j_1) + ', strength=' + this.q4j_1 + ')';
      }
      hashCode() {
        var result = Duration__hashCode_impl_u4exz6(this.p4j_1);
        result = imul(result, 31) + this.q4j_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KnownDeviceOptions()))
          return false;
        if (!(this.p4j_1 === other.p4j_1))
          return false;
        if (!(this.q4j_1 === other.q4j_1))
          return false;
        return true;
      }
      static r4j(seen0, duration, strength, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_6().n4j_1);
        }
        var $this = createThis(this);
        $this.p4j_1 = duration;
        $this.q4j_1 = strength;
        return $this;
      }
    }
    initMetadataForClass($, 'KnownDeviceOptions', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
    KnownDeviceOptionsClass = $;
  }
  return KnownDeviceOptionsClass;
}
function KnownDeviceSecretAndExpiration$Companion$$childSerializers$_anonymous__sohrqr() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      constructor() {
        Companion_instance_7 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.u3j_1 = [null, lazy(tmp_0, KnownDeviceSecretAndExpiration$Companion$$childSerializers$_anonymous__sohrqr)];
      }
      m2a() {
        return $serializer_getInstance_7();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_7;
function Companion_getInstance_7() {
  if (Companion_instance_7 === VOID)
    new (Companion_7())();
  return Companion_instance_7;
}
var $serializerClass_7;
function $serializer_7() {
  if ($serializerClass_7 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_7 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.KnownDeviceSecretAndExpiration', this, 2);
        tmp0_serialDesc.c1b('secret', false);
        tmp0_serialDesc.c1b('expiresAt', false);
        this.s4j_1 = tmp0_serialDesc;
      }
      t4j(encoder, value) {
        var tmp0_desc = this.s4j_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_7().u3j_1;
        tmp1_output.a15(tmp0_desc, 0, value.u4j_1);
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.v4j_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.t4j(encoder, value instanceof KnownDeviceSecretAndExpiration() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.s4j_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_7().u3j_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return KnownDeviceSecretAndExpiration().w4j(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.s4j_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_7().u3j_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_7 = $;
  }
  return $serializerClass_7;
}
var $serializer_instance_7;
function $serializer_getInstance_7() {
  if ($serializer_instance_7 === VOID)
    new ($serializer_7())();
  return $serializer_instance_7;
}
var KnownDeviceSecretAndExpirationClass;
function KnownDeviceSecretAndExpiration() {
  if (KnownDeviceSecretAndExpirationClass === VOID) {
    class $ {
      toString() {
        return 'KnownDeviceSecretAndExpiration(secret=' + this.u4j_1 + ', expiresAt=' + this.v4j_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.u4j_1);
        result = imul(result, 31) + this.v4j_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KnownDeviceSecretAndExpiration()))
          return false;
        if (!(this.u4j_1 === other.u4j_1))
          return false;
        if (!this.v4j_1.equals(other.v4j_1))
          return false;
        return true;
      }
      static w4j(seen0, secret, expiresAt, serializationConstructorMarker) {
        Companion_getInstance_7();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_7().s4j_1);
        }
        var $this = createThis(this);
        $this.u4j_1 = secret;
        $this.v4j_1 = expiresAt;
        return $this;
      }
    }
    initMetadataForClass($, 'KnownDeviceSecretAndExpiration', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
    KnownDeviceSecretAndExpirationClass = $;
  }
  return KnownDeviceSecretAndExpirationClass;
}
//region block: init
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
Companion_instance_3 = new (Companion_3())();
Companion_instance_4 = new (Companion_4())();
Companion_instance_5 = new (Companion_5())();
Companion_instance_6 = new (Companion_6())();
//endregion
//region block: exports
export {
  FinishProof as FinishProoflhqad7xhem5u,
  Proof as Proof19kcc739cbo52,
  Companion_getInstance_2 as Companion_getInstanceljo2w2l50tif,
  Companion_instance_0 as Companion_instance1ih0rts2yeaav,
  Companion_instance_5 as Companion_instance34pd77z7qkvav,
  Companion_instance_1 as Companion_instance1pkyovfo1ue86,
  Companion_instance_6 as Companion_instanceijunt7dscbn,
  Companion_getInstance_7 as Companion_getInstance3vf10yxur8dlu,
  $serializer_getInstance as $serializer_getInstancestor8ej9dr0n,
  Companion_getInstance as Companion_getInstance24vxhhaq3p126,
  Companion_instance_4 as Companion_instancegcdka3oz2z8g,
  $serializer_getInstance_3 as $serializer_getInstance3v9seicvbql6t,
  Companion_instance_3 as Companion_instance14gv80x39ekce,
};
//endregion

//# sourceMappingURL=proofModels.mjs.map
